import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useLang } from '../i18n';

// Выбор «что я учу» до входа: от него зависят язык интерфейса и курс при регистрации
export default function LangSwitch() {
  const { lang, setLang, t } = useLang();
  return (
    <ToggleButtonGroup size="small" exclusive value={lang} onChange={(_, v) => v && setLang(v)}
      aria-label={t('auth.language')} sx={{ mb: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
      <ToggleButton value="ru" sx={{ textTransform: 'none' }}>🇷🇺 Учу итальянский</ToggleButton>
      <ToggleButton value="it" sx={{ textTransform: 'none' }}>🇮🇹 Imparo il russo</ToggleButton>
    </ToggleButtonGroup>
  );
}
